import PropTypes from 'prop-types';

const Title = ({ type, groupName }) => {
  switch (type) {
    case 'ocean-link':
      return (
        <div>
          <div className="cmb-4">Link with Ocean</div>
          <div className="fw-bold fs-12 text-dark">{groupName}</div>
        </div>
      );
    case 'link':
      return (
        <div>
          <div className="cmb-4">Link with Company's Existing</div>
          <div className="fw-bold fs-12 text-dark">{groupName}</div>
        </div>
      );
    case 'edit':
      return <div>Edit Item</div>;
    case 'create':
      return <div>Create new Item</div>;
    case 'import':
      return (
        <div>
          <div className="cmb-4">Import to Company</div>
          <div className="fw-bold fs-12 text-dark">{groupName}</div>
        </div>
      );
    case 'equivalent':
      return (
        <div>
          <div className="cmb-4">Equivalent Items</div>
          <div className="fw-bold fs-12 text-dark">{groupName}</div>
        </div>
      );
    default:
      return null;
  }
};

const Header = ({ type, groupName }) => {
  return <Title type={type} groupName={groupName} />;
};

export default Header;

Header.propTypes = {
  type: PropTypes.string.isRequired,
  groupName: PropTypes.string
};

Title.propTypes = {
  type: PropTypes.string.isRequired,
  groupName: PropTypes.string
};
